import { promotionEvaluationFromResponse } from './promotionEvaluation'
import { fromEvaluation, type CheckoutPromotionViewData } from './offerBenefits'

/** Applied promotion amounts from order response. Display-only. */
export interface OrderPromotion {
  discount?: number | null
  cashback?: number | null
  set_item_price_savings?: number | null
  setItemPriceSavings?: number | null
}

export function parseOrderPromotion(raw: unknown): OrderPromotion | undefined {
  if (!raw || typeof raw !== 'object') return undefined
  const map = raw as Record<string, unknown>
  return {
    discount: asNullableNumber(map.discount),
    cashback: asNullableNumber(map.cashback),
    set_item_price_savings: asNullableNumber(
      map.set_item_price_savings ?? map.setItemPriceSavings,
    ),
  }
}

export function hasDisplayableOrderPromotion(
  promotion: OrderPromotion | null | undefined,
): boolean {
  if (!promotion) return false
  const discount = promotion.discount ?? 0
  const cashback = promotion.cashback ?? 0
  const savings =
    promotion.set_item_price_savings ?? promotion.setItemPriceSavings ?? 0
  return discount > 0 || cashback > 0 || savings > 0
}

function asNullableNumber(value: unknown): number | null | undefined {
  if (value == null) return undefined
  const parsed = typeof value === 'number' ? value : parseFloat(String(value))
  return Number.isNaN(parsed) ? undefined : parsed
}

/** Maps order.promotion for display-only UI. No evaluate API. */
export function fromOrderPromotion(
  promotion: OrderPromotion | null | undefined,
): CheckoutPromotionViewData {
  if (!hasDisplayableOrderPromotion(promotion)) {
    return { offers: [], freeItems: [] }
  }
  const evaluation = promotionEvaluationFromResponse({
    data: {
      discount: promotion!.discount,
      cashback: promotion!.cashback,
      set_item_price_savings:
        promotion!.set_item_price_savings ?? promotion!.setItemPriceSavings,
    },
  })
  return fromEvaluation(evaluation)
}
